<script setup>
import { ref, reactive, computed, onMounted, watch } from 'vue';
import { useSertStore } from '@/stores/sertStore';
import { getPaymentUrl } from '@/utils/services';
import { useRequestsStore } from '@/stores/storeRequests';
import BaseCheckbox from '@/components/ui/BaseCheckbox.vue';
import BaseBtnLookSert from '../ui/BaseBtnLookSert.vue';

const storeSert = useSertStore();
const storeRequests = useRequestsStore();

const loaderActive = ref(false);
const rentalInfo = ref({});
const isSucceeded = computed(() => rentalInfo.value.transaction.status === "succeeded")
const isPhysicalCertificate = computed(() => storeSert.checkedItems.select?.title >= 11000)



const nextSreen = async () => {	
	const response = await storeRequests.getPaymentUrl();
	if(!response?.success) return;
	window.location.href = storeRequests.payData?.transaction.payment_link;
	sessionStorage.setItem('rentalId', storeRequests.payData?.id); 
}

const previousSreen = () => {
    storeSert.goToScreen(storeSert.screens.sum)
    history.pushState(null, "", `#${storeSert.screens.sum}`)
    storeRequests.responseError = null
}

onMounted( async() => {

    const rentalId = sessionStorage.getItem("rentalId");
    const rentalIdNum = rentalId ? Number(rentalId) : null;

    if(rentalIdNum) {
        loaderActive.value = true
        rentalInfo.value = await storeRequests.getRentalInfo(rentalIdNum);
        sessionStorage.removeItem("rentalId")
        if(isSucceeded.value) {
            storeSert.goToScreen(storeSert.screens.thank)
        }
        loaderActive.value = false
    }

    if(!isPhysicalCertificate.value) {
        storeSert.updateCheckedItem('physicalCertificate', 'title', false)
    }

});

const formatted = new Intl.NumberFormat('ru-RU').format(storeSert.checkedItems.select.title);

</script>
<template>
    <div class="constructor">
        <div class="constructor__body">
            <div class="total">
                <h3 class="title3">Вы приобретаете:</h3>
                <h3 class="title3">Итого:</h3>
                <p class="total__desc">Подарочный сертификат номиналом {{ formatted }} рублей</p>
                <span class="total__price">{{ formatted }} ₽</span>
            </div>    
            <div class="rules" v-if="isPhysicalCertificate">            
                <BaseCheckbox
                    state-key="physicalCertificate"
                >
                    Поставьте галочку, если необходим выпуск физического сертификата (его можно получить на стойке администрации при посещении клуба The Rink Fitness).
                </BaseCheckbox>              
            </div>
            <ul class="preview-list">
                <li>Проверьте все данные: сумма, имя получателя, персональное сообщение и дизайн.</li>
                <li>Если все верно, нажмите  "Оплатить" для перехода к оплате.</li>
            </ul>
            <p>Убедитесь, что все данные верны и дизайн соответствует вашим ожиданиям.</p>
        </div>
        <div class="constructor__btns-inner">
            <p class="text-error" v-if="storeRequests.responseError">{{ storeRequests.responseError }}</p>
            <div class="constructor__btns">
                <button class="btn --black" @click="previousSreen">
                    <span>Назад</span>
                </button>
                <button :disabled="storeSert.isBtnDisabled(['select'])" class="btn --full" @click="nextSreen">
                    <span v-if="!storeRequests.loaderBtn">Оплатить</span>
                    <img v-else class="form__loader" width="36" height="36" src="@/assets/img/icons/loader_black.png" alt="изображение" />
                </button>
                <BaseBtnLookSert/>
            </div>
        </div>
    </div>
</template>
<style lang='scss' scoped>
@use '@/assets/scss/base/vars';
.total {
    display: grid;
    grid-template-columns: 1fr 25.5rem;
    gap: 4rem 5.5rem;
    @media (max-width: vars.$m) {
        grid-template-columns: 1fr 20rem;
    }
    @media (max-width: vars.$xx) {
        grid-template-columns: 1fr 1fr;
        gap: 2.4rem;
    }
    @media (max-width: vars.$x480) {
        gap: 1.2rem;
    }
    .title3:nth-child(1) {
        @media (max-width: vars.$xx) {        
            grid-column: 1/3;
        } 
    }
}
.total__desc {
    @media (max-width: vars.$xx) {
        grid-column: 1/3;
        grid-row: 2/3;
    }
}
.total__price {
    font-weight: 700;
    @media (max-width: vars.$xx) {
        justify-self: end;
        font-size: 2rem;
    }
} 

.rules {
    display: grid;
    gap: 1.5rem;
    padding-top: 1.5rem;
    border-top: 1px solid var(--border-default-4);
    @media (max-width: vars.$xx) {
        gap: 2rem;
    }
}
.checkbox__text {
    a {
        border-bottom: .1rem solid;
        @media (hover: hover){
            &:hover {
                border-color: transparent;
            }
        }
    }
}

.v-enter-active,
.v-leave-active {
  transition: 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}
</style>